function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 48,
    viewBox: "0 0 49 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M45.5 18V13.5H44V9H42.5V7.5H41V6H39.5V4.5H38V3H35V1.5H29V0H18.5V1.5H12.5V3H9.5V4.5H8V6H6.5V7.5H5V9H3.5V13.5H2V18H0.5V28.5H2V33H3.5V37.5H5V39H6.5V40.5H8V42H9.5V43.5H12.5V45H18.5V46.5H29V45H35V43.5H38V42H39.5V40.5H41V39H42.5V37.5H44V33H45.5V28.5H47V18H45.5Z",
    fill: "white",
    style: {
      fill: "white",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 18V13.5H44V9H42.5V7.5H41V6H39.5V4.5H38V3H35V1.5H29V0H18.5V1.5H12.5V3H9.5V4.5H8V6H6.5V7.5H5V9H3.5V13.5H2V18H0.5V28.5H2V33H3.5V37.5H5V39H6.5V40.5H8V42H9.5V43.5H12.5V45H18.5V46.5H29V45H35V43.5H38V42H39.5V40.5H41V39H42.5V37.5H44V33H45.5V28.5H47V18H45.5ZM14 22.5H15.5V19.5H17V16.5H18.5V13.5H20V12H21.5V9H23V7.5H24.5V9H26V12H27.5V13.5H29V16.5H30.5V19.5H32V22.5H33.5V24H32V25.5H29V27H26V28.5H24.5V30H23V28.5H21.5V27H18.5V25.5H15.5V24H14V22.5ZM35 27H33.5V28.5H32V30H30.5V33H29V34.5H27.5V36H26V37.5H24.5V39H23V37.5H21.5V36H20V34.5H18.5V33H17V30H15.5V28.5H14V27H12.5V25.5H14V27H17V28.5H20V30H21.5V31.5H26V30H27.5V28.5H30.5V27H33.5V25.5H35V27Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEth);
export default __webpack_public_path__ + "static/media/eth.072413dbd6223fdb335d8f10b2678309.svg";
export { ForwardRef as ReactComponent };